import React from "react";
import styled from "styled-components";
import { imgText } from "../Views/Cameras/imgText";
import storageService from "../../../services/storageService";

const DEFAULT_IMG = "images/320x180_blank.gif";

const StyledSection = styled.section`
  overflow: hidden;
  position: relative;
  width: 640px;
  height: 360px;
  flex-shrink: 0;

  img.cameraFeed {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    z-index: 1050;
  }
  img.heatOverlay {
    z-index: 1090;
    opacity: 0.4;
    /* opacity: 1; */
    border-radius: 4px;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 640px;
    height: 360px;
  }
`;

export interface CameraWideImageProps {
  showHeatmap: boolean;
  image: string;
  heatmap: string;
}

//Layout is determined here
const CameraWideImage: React.FC<CameraWideImageProps> = props => {
  const { image, heatmap } = props;
  const imageSrc = image ? storageService.signURL(image) : DEFAULT_IMG;
  const heatmapSrc = heatmap ? storageService.signURL(heatmap) : DEFAULT_IMG;
  return (
    <>
      <StyledSection>
        <img className="cameraFeed" src={imageSrc}></img>
        {props.showHeatmap && (
          <img className="heatOverlay" src={heatmapSrc}></img>
        )}
      </StyledSection>
    </>
  );
};

export default CameraWideImage;
